import React from "react";
import PageWrapper from "../components/PageWrapper";

export default function Vote() {
  return (
    <PageWrapper>
      <div
        style={{
          maxWidth: "900px",
          margin: "auto",
          borderRadius: "32px",
          padding: "32px 18px",
          background: "rgba(0,0,0,0.10)",
          boxSizing: "border-box"
        }}
      >
        <h1 style={{
          fontSize: "2em",
          color: "#FFD700",
          fontWeight: "bold",
          marginBottom: "18px"
        }}>Vote for MONKZI</h1>

        <p style={{
          color: "#fff",
          fontSize: "1.1em",
          marginBottom: "22px",
          lineHeight: "1.7"
        }}>
          Help MONKZI rise up the ranks! Vote for us on these platforms daily to boost our visibility, bring in new holders, and grow our community.
        </p>

        <ul style={{
          color: "#FFD700",
          fontSize: "1.12em",
          marginBottom: "24px",
          paddingLeft: "18px"
        }}>
          <li><a href="https://coinsniper.net/coin/84164" target="_blank" rel="noopener noreferrer" style={{ color: "#FFD700" }}>CoinSniper</a></li>
          <li><a href="https://coinhunt.cc/coin/68886ae4f3b2fcf77fe96ccf" target="_blank" rel="noopener noreferrer" style={{ color: "#FFD700" }}>CoinHunt</a></li>
          <li><a href="https://coinvote.cc/coin/monkzi" target="_blank" rel="noopener noreferrer" style={{ color: "#FFD700" }}>CoinVote</a></li>
          <li><a href="https://coinmooner.com/coins/monkilla-monkzi" target="_blank" rel="noopener noreferrer" style={{ color: "#FFD700" }}>CoinMooner</a></li>
          <li><a href="https://www.rugfreecoins.com/coin-details/31751" target="_blank" rel="noopener noreferrer" style={{ color: "#FFD700" }}>RugFreeCoins</a></li>
          <li><a href="https://www.freshcoins.io/coins/monkilla" target="_blank" rel="noopener noreferrer" style={{ color: "#FFD700" }}>FreshCoins</a></li>
        </ul>

        <div style={{
          color: "#FFD700",
          marginTop: "18px",
          fontWeight: "bold"
        }}>
          Voting daily helps Monkzi trend and brings more rewards for the community!
        </div>
      </div>
      {/* --- SOCIAL LINKS --- */}
        <div style={{
          marginTop: "38px",
          borderTop: "1.5px solid #404040",
          padding: "24px 0 8px 0",
          textAlign: "center"
        }}>
          <span style={{ fontWeight: "bold", marginRight: "18px", color: "#FFD700" }}>Follow us:</span>
          <a href="https://t.me/monkillaofficial" target="_blank" rel="noopener noreferrer" style={{ color: "#0088cc", margin: "0 14px", fontWeight: "bold" }}>Telegram</a>
          <a href="https://twitter.com/monkillacoin" target="_blank" rel="noopener noreferrer" style={{ color: "#1da1f2", margin: "0 14px", fontWeight: "bold" }}>X (Twitter)</a>
          <a href="https://instagram.com/monkilla.official" target="_blank" rel="noopener noreferrer" style={{ color: "#d6249f", margin: "0 14px", fontWeight: "bold" }}>Instagram</a>
          <a href="https://www.facebook.com/profile.php?id=61578002207190" target="_blank" rel="noopener noreferrer" style={{ color: "#d6249f", margin: "0 14px", fontWeight: "bold" }}>Facebook</a>
		<a href="https://discord.gg/q8MDWV4K" target="_blank" rel="noopener noreferrer" style={{ color: "#d6249f", margin: "0 14px", fontWeight: "bold" }}>Discord</a>
          <a href="mailto:info@monkilla.com" style={{ color: "#FFD700", margin: "0 14px", fontWeight: "bold" }}>Email</a>
        </div>
      <style>{`
        @media (max-width: 700px) {
          .page-card {
            min-width: 92vw !important;
            max-width: 99vw !important;
            padding: 18px 5vw !important;
          }
        }
      `}</style>
    </PageWrapper>
  );
}
